export default {
  authorizedRedirections: [
    /^\/$/,
    /^\/publish/,
    /^\/login/,
    /^\/explorer/,
    /^\/portal/,   
    /^\/maps/,
    /^\/dossiers/,
  ],
  customHeaderAndFooter: true,
  client: {
    name: "Neogeo",
    email: "contact@neogeo.fr"
  },
  forms: {
    signin: {
      title: {
        en: "Enter your login",
        fr: "Saisissez vos identifiants",
      }
    },
    signup: {
      disabled: true,
      hiddenFields: [],
      requiredFields: [
        'first_name',
        'last_name',
        'email',
      ],
    },
    organisation: {
      hiddenFields: [],
      requiredFields: [
        'name',
        'type',
      ],
    },
  }
};
